import { render, staticRenderFns } from "./NonStandardTable.vue?vue&type=template&id=4acd4998&"
import script from "./NonStandardTable.vue?vue&type=script&lang=js&"
export * from "./NonStandardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports